import React from 'react'
import './LoaderRow.scss'

const LoaderRow: React.FC = () => {
  return (
    <div className="loader-row">
      <div className="loader-spinner">
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={i} className={`spinner-segment seg-${i}`} />
        ))}
      </div>
      <span className="loader-text">Подождите, идёт загрузка данных…</span>
    </div>
  )
}

export default LoaderRow
